import type { ComponentChildren } from 'preact';
import './Table.css';

export interface TableColumn<T> {
  key: string;
  header: string;
  render: (row: T) => ComponentChildren;
  width?: string;
}

interface Props<T> {
  columns: TableColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string;
  onRowClick?: (row: T) => void;
  emptyLabel?: string;
}

/** Plain HTML table with token styling. No sort/filter/virtualization yet —
 *  that's Tier-3 territory (TanStack Table headless), out of scope. */
export function Table<T>({ columns, rows, rowKey, onRowClick, emptyLabel = 'No entries' }: Props<T>) {
  if (rows.length === 0) {
    return <div class="hv-table__empty">{emptyLabel}</div>;
  }
  return (
    <div class="hv-table__wrap">
      <table class="hv-table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key} style={c.width ? `width:${c.width}` : undefined}>{c.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={rowKey(row)}
              class={onRowClick ? 'hv-table__row--clickable' : undefined}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((c) => (
                <td key={c.key}>{c.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
